import { Invite } from "@/types";

import axios from "./axios";

const sendInvite = async (invite: Invite) => {
  const { data } = await axios.post("/invite", invite);
  return data;
};

const getInvite = async (id: string) => {
  const { data } = await axios.get(`/invite/${id}`);
  return data;
};

const getAll = async () => {
  const { data } = await axios.get("/invite");
  return data;
};

const deleteById = async (id: string) => {
  const { data } = await axios.delete(`/invite/${id}`);
  return data;
};

const resendInvite = async (invite: Invite) => {
  const { data } = await axios.post("/invite/resend", invite);
  return data;
};

const importPatients = async (formData: FormData) => {
  const { data } = await axios.post(`/invite/import-patients`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const InvitesApi = {
  sendInvite,
  getInvite,
  getAll,
  deleteById,
  resendInvite,
  importPatients,
};
